import Logo from "assets/images/ppwb/ppwb_logo.svg";
import ParpLogo from "assets/images/parp/parp-logo.png";
import Image from "gatsby-image";
import React from "react";
import HeroType from "../../Types/heros";
import { useHeroPhoto } from "./useHeroPhoto";
import ParpVideo from 'assets/videos/parp.mp4';

const useHerosTypesData = (type) => {
  const images = useHeroPhoto();

  const menu_design_category = [
    { title: "Webdesign", slug: "/uslugi/web-design" },
    { title: "Branding", slug: "/uslugi/branding" },
    { title: "Ilustracje", slug: "/uslugi/ilustracje" },
    { title: "Grafika 3D", slug: "/uslugi/grafika-3d" },
  ];

  const menu_marketing_category = [
    { title: "Social Media", slug: "/uslugi/social-media" },
    { title: "Google Ads", slug: "/uslugi/kampanie-ads" },
    { title: "Pozycjonowanie", slug: "/uslugi/pozycjonowanie-seo" },
    { title: "Copywriting", slug: "/uslugi/copywriting" },
  ];

  const menu_programming_category = [
    { title: "Strony www", slug: "/uslugi/strony-www" },
    { title: "Sklepy internetowe", slug: "/uslugi/sklepy-internetowe" },
    { title: "Aplikacje", slug: "/uslugi/aplikacje" },
  ];

  const menu_about_category = [
    { title: "Dlaczego my", href: "/o-nas#dlaczego-my" },
    { title: "Co robimy", href: "/o-nas#co-robimy" },
    { title: "Team", href: "/o-nas#team" },
    { title: "Czym się wyróżniamy", href: "/o-nas#standout" },
  ];

  const data = {
    [HeroType.ABOUT]: {
      title: "O nas",
      header: <>Agencja <br/> nie z tej Ziemi</>,
      seo:
        "Do każdego klienta podchodzimy indywidualnie. Potrafimy sprostać najbardziej kosmicznym oczekiwaniom!",
      text: (
        <>
          Jesteś naszym partnerem, a nie kolejnym projektem. Stanowimy kreatywny i zaangażowany zespół specjalistów.
          Potrafimy sprostać nawet najbardziej kosmicznym oczekiwaniom! Wspólnie osiągniemy sukces.
        </>
      ),
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.about.childImageSharp.fluid}
        />
      ),
      menu: menu_about_category,
    },
    [HeroType.BLOG]: {
      title: "Blog",
      header: (
        <>
          Odkryj
          <br/>
          bazę wiedzy
        </>
      ),
      seo:
        "Jesteś gotowy na kosmiczną dawkę wiedzy? Przeczytaj najświeższe artykuły i poznaj najnowsze trendy w marketingu. ",
      text: (
        <>
          Przeczytaj najświeższe artykuły i poznaj najnowsze trendy w marketingu. Dowiedz się, na jakie elementy zwracać uwagę przy prowadzeniu własnego biznesu i dlaczego warto inwestować we własną markę.
        </>
      ),
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.blog.childImageSharp.fluid}
        />
      ),
    },
    [HeroType.CAREER]: {
      title: "Kariera",
      header: <>
        Zostań członkiem <br/>
        załogi InteractiveVision
      </>,
      seo:
        "Zostań członkiem załogi InteractiveVision! Czujesz, że dzięki Tobie poszybujemy jeszcze wyżej? Być może czekamy właśnie na Ciebie!",
      text: (
        <>
          Czekamy właśnie na Ciebie! Jeśli chcesz razem z nami odkrywać nowe światy, zapraszamy na nasz statek. <br/>
          Napisz do nas: <a href="mailto:rekrutacja@interactivevision.pl">
          rekrutacja@interactivevision.pl
        </a>
        </>
      ),
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.kariera.childImageSharp.fluid}
        />
      ),
    },
    [HeroType.CONTACT]: {
      title: "Kontakt",
      header: <>
        Nawiąż <br/>
        z&nbsp;nami kontakt
      </>,
      seo:
        "Zadzwoń, napisz lub odwiedź nas biurze. Zrobimy co naszej mocy, abyś z nami osiągnął zamierzone cele.",
      text: (
        <>
          Zrób pierwszy krok, a&nbsp;my zajmiemy się resztą. Z&nbsp;nami osiągniesz wyznaczone cele.
          <br/>
          Działamy jak grawitacja - przyciągamy najlepsze rozwiązania.
        </>
      ),
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.contact.childImageSharp.fluid}
        />
      ),
    },
    [HeroType.OFFER]: {
      title: "Oferta",
      header: (
        <>
          InteractiveVision
          <br/>
          to nieskończone możliwości
        </>
      ),
      seo:
        "Tworzymy strony internetowe, sklepy internetowe, marketing w sieci i wiele więcej. Zobacz nasze kosmiczne możliwości.",
      text: (
        <>
          Stworzymy strategię marki, spójną komunikację i&nbsp;plan marketingowy. Zadbamy o&nbsp;identyfikację wizualną, stronę internetową, marketing oraz wszystkie jego elementy: projekty graficzne, multimedia oraz promocję i&nbsp;reklamę.
        </>
      ),
      button: {
        title: "Pobierz prezentację",
        href: "/uslugi/prezentacja-interactivevision.pdf",
      },
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.oferta.childImageSharp.fluid}
        />
      ),
    },
    [HeroType.OFFER_3D_DESIGN]: {
      title: "Grafika 3D",
      header: <>Grafika i projektowanie 3D na miarę przyszłości</>,
      seo:
        "Szczegółowo pokażemy produkt, który oferujesz. Nasz kreatywny zespół stanie na wysokości zadania.",
      text: (
        <>
          Wizualizacje i projekty 3D to innowacyjne rozwiązania dla Twojej
          marki. Szczegółowo pokażemy produkt, który oferujesz. Zapewniamy, że
          nasze artystyczne i&#160;kreatywne dusze staną na wysokości zadania.
        </>
      ),
      category: "Design",
      color: "#49AD56",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.models.childImageSharp.fluid}
        />
      ),
      menu: menu_design_category,
    },
    [HeroType.OFFER_APPS]: {
      title: "Aplikacje mobilne",
      header: (
        <>
          Aplikacja mobilna to <br/>
          innowacja w Twoim biznesie
        </>
      ),
      seo:
        "Zaprojektujemy aplikację mobilną, która umożliwi nieograniczony, mobilny dostęp do Twojego serwisu.",
      text: (
        <>
          Zaprojektujemy aplikację mobilną, która umożliwi nieograniczony dostęp
          do Twojego serwisu za pomocą smartfona. Przyciągnie też nowych
          klientów i&#160;pomoże w prowadzeniu biznesu. To centrum dowodzenia
          Twojej marki.
        </>
      ),
      category: "Programowanie",
      color: "#5D00E1",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.apps.childImageSharp.fluid}
        />
      ),
      menu: menu_programming_category,
    },
    [HeroType.OFFER_BRANDING]: {
      title: "Branding",
      header: (
        <>
          Zbuduj markę, z&#160;którą inni chcą <br/>
          się utożsamiać
        </>
      ),
      seo:
        "Wspólnie opracujemy identyfikację wizualną zaproponujemy szereg rozwiązań, dzięki którym Twoja marka wyróżni się wśród konkurencji.",
      text: (
        <>
          Wspólnie opracujemy identyfikację wizualną i&#160;zaproponujemy szereg
          rozwiązań, dzięki którym Twoja marka wyróżni się wśród konkurencji.
          Budowanie świadomości marki to proces. Ty ustalasz dystans, my
          ułatwiamy jego pokonanie.
        </>
      ),
      category: "Design",
      color: "#FBC116",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.branding.childImageSharp.fluid}
        />
      ),
      menu: menu_design_category,
    },
    [HeroType.OFFER_COPYWRITING]: {
      title: "Copywriting",
      header: (
        <>
          Słowa mają moc, czyli teksty, które <br/>
          sprzedają
        </>
      ),
      seo:
        "Przygotujemy oferty handlowe, opisy produktów, hasła reklamowe, treści spotu radiowego, artykuły tematyczne i wiele innych.",
      text: (
        <>
          Napiszemy dla Ciebie wszystko! Teksty na stronę WWW i&#160;blogi.
          Przygotujemy oferty handlowe, opisy produktów, hasła reklamowe, treści
          spotu radiowego, artykuły tematyczne i&#160;wiele innych. Zredagujemy
          również gotowe teksty, dbając o&#160;ich poprawność
          i&#160;kreatywność.
        </>
      ),

      category: "Design",
      color: "#FBC116",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.copy.childImageSharp.fluid}
        />
      ),
      menu: menu_marketing_category,
    },
    [HeroType.OFFER_ECOMMERCE]: {
      title: "Sklepy internetowe",
      header: (
        <>
          Sklepy internetowe - wygodna <br/>
          i efektywna sprzedaż online
        </>
      ),
      seo:
        "Zapewniamy dedykowane autorskie rozwiązania e-commerce. Projektujemy, wdrażamy obsługujemy sklepy internetowe.",
      text: (
        <>
          Zapewniamy dedykowane i&#160;autorskie rozwiązania e-commerce.
          Projektujemy, wdrażamy i&#160;obsługujemy sklepy internetowe.
          Wspieramy sprzedaż aktywnymi działaniami marketingowymi.
        </>
      ),
      category: "Design",
      color: "#49AD56",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.ecommerce.childImageSharp.fluid}
        />
      ),
      menu: menu_programming_category,
    },
    [HeroType.OFFER_GOOGLEADS]: {
      title: "Kampanie google",
      header: (
        <>
          Ponad 90% internautów <br/>
          korzysta z wyszukiwarki Google
        </>
      ),
      seo:
        "Reklamy Google Ads to numer jeden pośród wszystkich systemów reklamowych, dzięki którym wyświetlimy Twoje linki.",
      text: (
        <>
          Reklamy Google Ads to numer jeden pośród wszystkich systemów
          reklamowych, dzięki którym wyświetlimy Twoje linki. Połączone siły
          stron współpracujących w&#160;ramach programu Google AdSense pozwoli
          na pokazanie Twojej reklamy w&#160;każdym zakątku internetu.
        </>
      ),
      category: "Design",
      color: "#5A1CE4",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.ads.childImageSharp.fluid}
        />
      ),
      menu: menu_marketing_category,
    },
    [HeroType.OFFER_ILLUSTRATION]: {
      title: "Ilustracje",
      header: (
        <>
          Autorskie ilustracje nadadzą Twojej
          <br/> marce oryginalności i&#160;autentyczności
        </>
      ),
      seo:
        "Przygotujemy atrakcyjne i oryginalne ilustracje, które podkreślą Twój indywidualizm i wyjątkowość.",
      text: (
        <>
          Projekty graficzne to elementy, które przykuwają największą uwagę.
          Warto zadbać, by wyróżniały się w&#160;Twoich reklamach. Przygotujemy
          atrakcyjne i&#160;oryginalne ilustracje, które podkreślą
          Twój indywidualizm i&#160;wyjątkowość.
        </>
      ),
      category: "Design",
      color: "#5D00E1",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.ilustracje.childImageSharp.fluid}
        />
      ),
      menu: menu_design_category,
    },
    [HeroType.OFFER_MEDIA]: {
      title: "Media",
      header: (
        <>
          Profesjonalne materiały
          <br/>
          fotograficzne i&#160;wideo
        </>
      ),
      seo:
        "Wysokiej jakości ujęcia to podstawa skutecznej reklamy i baza przy tworzeniu materiałów marketingowych.",
      text: (
        <>
          Profesjonalne materiały foto i&#160;wideo są portalem do nowych
          możliwości. Wysokiej jakości ujęcia to podstawa skutecznej reklamy
          i&#160;baza przy tworzeniu materiałów marketingowych.
        </>
      ),
      button: {
        title: "Portfolio fotogragficzne",
        href: "http://fotografia.interactivevision.pl/",
      },
      category: "Marketing",
      color: "#FBC116",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.media.childImageSharp.fluid}
        />
      ),
    },
    [HeroType.OFFER_SEO]: {
      title: "Pozycjonowanie",
      header: (
        <>
          Pozycjonowanie stron internetowych to <br/>
          kluczowy element obecności w sieci
        </>
      ),
      seo:
        "Wypozycjonujemy Twoją stronę WWW, zwiększając Twoją widoczność w sieci i ułatwiając dotarcie do Ciebie klientom.",
      text: (
        <>
          Najbardziej dochodowe marki na świecie swój sukces zawdzięczają
          wysokiej pozycji w&#160;wyszukiwarce. Chcesz być jedną z nich?
          Powiedz, do kogo kierujesz ofertę i&#160;jaki charakter ma Twoja
          marka, a&#160;my wprowadzimy ją na rynek. SEO to podstawa
          funkcjonowania w&#160;internecie.
        </>
      ),
      color: "#49AD56",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.seo.childImageSharp.fluid}
        />
      ),
      menu: menu_marketing_category,
    },
    [HeroType.OFFER_SOCIALMEDIA]: {
      title: "Social media",
      header: (
        <>
          Social media to podstawa budowania <br/>
          pozytywnego wizerunku w sieci
        </>
      ),
      seo:
        "Zbudujemy Twoją markę w social mediach i społeczność wokół niej, a jej fanów zmienimy w Twoich klientów.",
      text: (
        <>
          Wybierzemy dla Twojej marki najlepszy kanał komunikacji
          z&#160;klientami, dobierzemy grupę odbiorców i&#160;skierujemy do niej
          odpowiednie komunikaty. Portale społecznościowe to medium, które nie
          traci na wartości. Inwestuj w&#160;rozwój swojej firmy przez
          skoordynowane działania w mediach społecznościowych.
        </>
      ),
      category: "Marketing",
      color: "#FBC116",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.social.childImageSharp.fluid}
        />
      ),
      menu: menu_marketing_category,
    },
    [HeroType.OFFER_WEBDESIGN]: {
      title: "Interfejsy stron i aplikacji",
      header: (
        <>
          Strony WWW i aplikacje to wirtualne <br/>
          wizytówki - zadbaj o ich wygląd
        </>
      ),
      seo:
        "Stworzymy dla Ciebie nie tylko wysoce estetyczny, ale przede wszystkim intuicyjny i przyjazny użytkownikom interfejs.",
      text: (
        <>
          Najważniejszy jest pierwszy kontakt z&#160;Twoją marką. Nie da się
          tego powtórzyć! Dobrze zaprojektowana strona internetowa lub aplikacja
          mobilna na długo zbudują pozytywny wizerunek marki i&#160;sprawnie
          poprowadzą Twoich klientów do celu. Wyjdź naprzeciw potrzebom swoich
          odbiorców!
        </>
      ),
      category: "Design",
      color: "#E40D70",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.offer_webdesigng.childImageSharp.fluid}
        />
      ),
      menu: menu_design_category,
    },
    [HeroType.OFFER_WEBPAGES]: {
      title: "Strony www",
      header: (
        <>
          Odpowiedni kod to podstawa <br/>
          szybkiej i&#160;wydajnej strony internetowej
        </>
      ),
      seo:
        "Opracujemy i wdrożymy szybką, wydajną i responsywną stronę internetową, która będzie wizytówką Twojej firmy.",
      text: (
        <>
          Tworzenie stron internetowych to jeden z naszych sposobów na
          zwiększenie Twoich zysków i&#160;rozpoznawalności. Użycie najnowszych
          technologii pozwala nam na połączenie użyteczności i&#160;wydajności
          z&#160;atrakcyjnym designem. Projektowane przez nas strony WWW
          przedstawią Twoją markę z&#160;jak najlepszej strony!
        </>
      ),

      category: "Programowanie",
      color: "#5D00E1",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.webpages.childImageSharp.fluid}
        />
      ),
      menu: menu_programming_category,
    },
    [HeroType.REALISATIONS]: {
      title: "Realizacje",
      header: (
        <>
          Agencja 360
          <br/>
          Kosmiczne projekty
        </>
      ),
      seo:
        "Strony WWW, aplikacje mobilne, e-commerce, Facebook, Instagram, social media, kampanie reklamowe - zobacz, co robimy.",
      text: (
        <>
          Strony WWW, aplikacje mobilne, e-commerce, social media: Facebook, Instagram, LinkedIn, TikTok, kampanie reklamowe. Przekonaj się, jak efektywne są kompleksowe działania marketingowe.
        </>
      ),
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.realisation.childImageSharp.fluid}
        />
      ),
    },
    [HeroType.REALISATIONS_DESIGN]: {
      title: "REALIZACJE / DESIGN",
      header: (
        <>
          Dobry design przyciąga nie tylko oko, <br/>
          ale też nowych klientów
        </>
      ),
      text: (
        <>
          Przemyślana identyfikacja wizualna sprawi, że zyskasz przewagę wśród
          konkurencji. Śledzimy bieżące trendy i&#160;wiemy, co zrobić, by
          wyróżnić Twoją markę na rynku. Opracujemy wszystkie elementy brandingu
          oraz księgę znaku.
        </>
      ),
      color: "#FBC116",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.r_design.childImageSharp.fluid}
        />
      ),
    },
    [HeroType.REALISATIONS_MARKETING]: {
      title: "REALIZACJE / MARKETING",
      header: (
        <>
          Marketing to nie sprint, <br/>
          marketing to maraton
        </>
      ),
      text: (
        <>
          Zajmujemy się kompleksowymi działaniami marketingowymi, zarówno
          w&#160;internecie, jak i&#160;reklamą outdoorową, reklamami radiowymi
          czy event marketingiem. Wymyślamy slogany, piszemy teksty, tworzymy
          kreatywne kampanie reklamowe.
        </>
      ),
      color: "#E40D70",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.r_marketing.childImageSharp.fluid}
        />
      ),
    },
    [HeroType.REALISATIONS_MEDIA]: {
      title: "REALIZACJE / MEDIA",
      header: (
        <>
          Atrakcyjny przekaz wizualny odmieni <br/>
          postrzeganie Twojej marki
        </>
      ),
      text: (
        <>
          Tworzone przez nas wysokiej jakości zdjęcia i&#160;wideo są podstawą
          skutecznej reklamy. Projektowane przez nas animacje wyróżniają naszych
          klientów na rynku. Dzięki nam wszyscy o&#160;Tobie usłyszą. Promocja
          w&#160;TV, radiu, prasie i&#160;reklama outdoorowa utrwalą Twój
          pozytywny wizerunek.
        </>
      ),
      color: "#E40D70",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.contact.childImageSharp.fluid}
        />
      ),
    },
    [HeroType.REALISATIONS_WEBDEV]: {
      title: "REALIZACJE / WEB APPS",
      header: (
        <>
          Strony WWW, sklepy internetowe,
          <br/> aplikacje - narzędzia dla Twojego biznesu
        </>
      ),
      text: (
        <>
          Projektujemy wydajne i&#160;szybkie strony internetowe. Tworzymy
          nowoczesne aplikacje mobilne. Wdrażamy profesjonalne
          i&#160;innowacyjne rozwiązania e-commerce. Stawiamy na jakość -
          używamy najnowszych technologii i&#160;wykorzystujemy autorskie
          systemy.
        </>
      ),
      color: "#5D00E1",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.r_webpages.childImageSharp.fluid}
        />
      ),
    },
    [HeroType.SOLUTIONS]: {
      title: "Rozwiązania",
      header: (
        <>
          Kompleksowe rozwiązania marketingowe
        </>
      ),
      seo:
        "Współpracujemy z większymi i mniejszymi firmami, klientami indywidualnymi, inwestorami czy dealerami samochodowymi.",
      text: (
        <>
          Stań się jedną z&nbsp;gwiazd w naszej galaktyce. Wierzymy, że nasze wartości takie jak odpowiedzialność, efektywność, doświadczenie, transparentność oraz odwaga pozwolą nam razem osiągnąć sukces.
        </>
      ),
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.solutions.childImageSharp.fluid}
        />
      ),
    },
    [HeroType.PPWB]: {
      title: "",
      icon: Logo,
      header: <>Kosmiczna refundacja <br/>Uzyskaj nawet <span>100 000 PLN </span> <br/>dla Twojej firmy!</>,
      seo: "Kosmiczna refundacja - uzyskaj nawet 100 000 PLN dla Twojej firmy!",
      text: null,
      biggerSize: true,
      color: "rgba(255,255,255, 0)",
      textColor: "#060770",
      spanColor: "#CE41AB",
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.ppwb.childImageSharp.fluid}
        />
      ),
    },
    [HeroType.PARP]: {
      title: "",
      icon: ParpLogo,
      iconWidth: 200,
      header: <>Otrzymaj nawet<br/> <span>900 000 zł</span><br/> dofinansowania!</>,
      seo: "Otrzymaj nawet 900 000 zł dofinansowania!",
      text: null,
      biggerSize: true,
      heroClass: 'parp-hero',
      color: "rgba(255,255,255, 0)",
      textColor: "#000",
      spanColor: "#5A1CE4",
      video: ParpVideo,
      image: (
        <Image
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.parp.childImageSharp.fluid}
        />
      ),
    },
  };

  return data[type];
};

export default useHerosTypesData;
